import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import {
    ApplicationEmptyState
} from 'core/components';
import {PreviewLayout} from 'core/layouts';

function UserPreviewTemplate({ userPreviewViewStore, t }) {
    const {
        item,
        loaderStore
    } = userPreviewViewStore;

    return (
        <PreviewLayout store={userPreviewViewStore} emptyRenderer={<ApplicationEmptyState />} loading={loaderStore.loading}>
            <div className="row is-preview">
                <div className="col col-sml-12 col-lrg-8">
                    <div className="card card--form card--primary card--med">
                        <h4 className="form__title form__title--preview u-mar--bottom--med">
                        {item && <React.Fragment>{item.firstName} {item.lastName}</React.Fragment>}
                        </h4>
                        <div className="row u-mar--bottom--lrg">
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('USER.PREVIEW.EMAIL')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.email}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('USER.PREVIEW.USERNAME')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.userName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('USER.PREVIEW.DISPLAY_NAME')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.displayName}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('USER.PREVIEW.ROLES')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.roleNames}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h4 className="form__title form__title--preview u-mar--bottom--med">
                        Log Info
                        </h4>
                        <div className="row">
                            <div className="col col-sml-12 col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('USER.PREVIEW.FIRST_ACCESS')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.creationDate}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-sml-12 col-lrg-8">
                                <div className="u-separator--preview">
                                    <div className="row">
                                        <div className="col col-sml-12 col-lrg-6">
                                            <div className="form__group__label is-preview">{t('USER.PREVIEW.LAST_ACCESS')}</div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-6">
                                            {item && <React.Fragment>{item.lastLoginDate}</React.Fragment>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PreviewLayout>
    )
}

UserPreviewTemplate.propTypes = {
    userPreviewViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

export default defaultTemplate(UserPreviewTemplate);
